<template>
    <div>
        <div
            class="readonly-label primary--text"
        >
            {{ label }}
        </div>
        <div
            class="readonly-value v-flex"
            :class="clazz"
            :style="style"
        >
            <div class="w-100 pr-1">
                {{ value }}
            </div>
            <v-spacer />
            <div>
                <slot name="prepend"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FReadOnlyField",

    props: {
        label: {

        },

        value: {

        },

        alignRight: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },

        dense: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },

        line: {
            required: false,
            type: Boolean,
            default: function () {
                return true;
            }
        },

        color: {
            required: false,
            type: String,
            default: function () {
                return null;
            }
        },

        filled: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },

        collective: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },

        frame: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },
    },
    computed: {
        style () {
            let style = this.alignRight ? 'text-align: right; ' : ' ';
            if (!this.dense) {
                style = style + "margin-bottom: 20px; ";
            }

            if (!this.line) {
                style = style + "border: none; min-height: 25px;"
            }

            return style;
        },

        clazz () {
            if (this.color) {
                return 'pt-0-5 pl-1 no-border ' + this.color;
            }

            let clazz = this.collective || this.frame || this.filled ? "pt-0-5 pl-1 " : "";
            if (this.collective) {
                clazz += "field-collective ";
            } else if (this.filled) {
                clazz += "ro-background ";
            }

            if (this.frame) {
                clazz += "field-frame ";
            }

            return clazz;
        }
    }
}
</script>

<style scoped>

.readonly-label {
    font-size: 11px;
}

.readonly-value {
    font-size: 15px;
    min-height: 32px;
    max-height: 32px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-top: 4px!important;
    padding-left: 8px!important;
    margin-bottom: 2px;
    padding-right: 5px;
    width: 100%;
    border-bottom-style: dotted;
    border-bottom-color: gray;
    border-width: 1px;
}


::v-deep .field-collective {
    border-top-left-radius: 6px!important;
    border-top-right-radius: 6px!important;
    background-color: #f5f5f5!important;
    padding-left: 4px!important;
    border-width: 3px;
    border-style: solid;
    border-color: aliceblue;
    padding-top: 1px!important;
}

</style>